import React, { Component } from 'react'
import styled from 'styled-components'
import { provideState, injectState } from 'freactal'
import app from '../../../feathers'

import { Route } from 'react-router-dom'
import { Grid, Cell } from 'react-mdl'
import Button from '../../../components/Button'
import FullAreaContent from '../../components/FullAreaContent'
import SummativePracticalAssessmentTasks from './SummativePracticalAssessmentTasks'
import FormativePracticalAssessments from './FormativePracticalAssessments'
import TaskMapping from './TaskMapping'

const StyledGrid = styled(Grid)`
  height: 100%;
  box-sizing: border-box;
  align-content: stretch;
`

const withState = provideState({
  initialState: () => ({
    addFormativePracticalAssessmentTaskError: null,
    updateFormativePracticalAssessmentTaskError: null,
  }),
  effects: {
    clearErrors: () => () => ({
      addFormativePracticalAssessmentTaskError: null,
      updateFormativePracticalAssessmentTaskError: null,
    }),
    addFormativePracticalAssessmentTask: async (effects, { _id, name }) => {
      try {
        await effects.clearErrors()
        await app.service('units').patch(_id, {
          $push: {
            formativePracticalAssessment: {
              name,
            },
          },
        })
      } catch (addFormativePracticalAssessmentTaskError) {
        return () => ({ addFormativePracticalAssessmentTaskError })
      }
    },
    updateFormativePracticalAssessmentTask: async (
      effects,
      {
        _id,
        formativePracticalAssessmentTaskIndex,
        formativePracticalAssessmentTask,
      },
    ) => {
      try {
        await effects.clearErrors()
        await app.service('units').patch(_id, {
          [`formativePracticalAssessment.${formativePracticalAssessmentTaskIndex}`]: formativePracticalAssessmentTask,
        })
      } catch (updateFormativePracticalAssessmentTaskError) {
        return () => ({ updateFormativePracticalAssessmentTaskError })
      }
    },
  },
})

class PresentationContent extends Component {
  addFormativePracticalAssessmentTask = async () => {
    const {
      state: { unit },
      effects: { addFormativePracticalAssessmentTask },
    } = this.props
    await addFormativePracticalAssessmentTask({
      _id: unit._id,
      name: 'New Formative Practical',
    })
  }
  updateFormativePracticalTask = async (
    formativePracticalAssessmentTask,
    formativePracticalAssessmentTaskIndex,
  ) => {
    const {
      state: { unit },
      effects: { updateFormativePracticalAssessmentTask },
    } = this.props
    await updateFormativePracticalAssessmentTask({
      _id: unit._id,
      formativePracticalAssessmentTask,
      formativePracticalAssessmentTaskIndex,
    })
  }
  render() {
    const {
      state: {
        unit: { summativePracticalAssessments, formativePracticalAssessment },
      },
    } = this.props
    return (
      <FullAreaContent>
        <StyledGrid>
          <Cell col={4} style={{ position: 'relative' }}>
            <SummativePracticalAssessmentTasks
              summativePracticalAssessments={summativePracticalAssessments}>
              Print out of the Summative Practical Assessments. (in order and
              showing all tasks & subtasks). This is for reference only.
            </SummativePracticalAssessmentTasks>
          </Cell>
          <Cell col={8}>
            <FormativePracticalAssessments
              tasks={formativePracticalAssessment}
              onUpdate={this.updateFormativePracticalTask}
            />
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button
                raised
                primary
                onClick={this.addFormativePracticalAssessmentTask}>
                Add Formative Practical Assessment Task
              </Button>
            </div>
          </Cell>
        </StyledGrid>
        <Route
          path="/units/:unitId/formative-practical-assessments/mapping/:taskIndex"
          component={TaskMapping}
        />
      </FullAreaContent>
    )
  }
}

export default withState(injectState(PresentationContent))



// WEBPACK FOOTER //
// ./src/Units/ManageUnit/FormativePracticalAssessments/index.js